<template>
  <div id="missionCompleted">
    <v-card
      class="mx-auto"
      max-width="600"
      min-width="300"
      min-height="100"
      color="#f6f6fa"
    >
    <p style="color:#FFFFFF;background-color:#5555BB"><b>ミッション中</b></p>
    <div v-if="isLeader">
      <div v-if="!sent">
        <p>リーダー({{ leader.name }})はボタンを押して下さい．</p>
        <div class="send-button">
          <sendButton v-on:pushed="showResult" label="ミッション結果を表示" active="true"/>
        </div>
      </div>
      <div v-else>
        <span>ゲーム情報を取得しています．</span>
      </div>
    </div>
    <div v-else>
      <p>リーダー({{ leader.name }})による<br>ミッション結果の開示を待っています．</p>
    </div>
  </v-card>
  </div>
</template>
<script>
import sendButton from '@/components/gameUiComponents/SendButton.vue'
export default {
  name: "missionCompleted",
  plops: [],
  components: {
    sendButton
  },
  data() {
    return {
      socket: this.$store.state.webSocket.socket,
      roomId: this.$store.getters.roomId,
      userName: this.$store.getters.userName,
      userId: this.$store.getters.userId,
      isLeader: this.$store.getters.isLeader,
      round: this.$store.getters.round,
      leader: this.$store.getters.leader,
      sent: false,
    };
  },
  computed: {
    requiredFails() {
      return this.$store.getters.requiredFails
    }
  },
  methods: {
    showResult() {
      // this.sent = true
      this.$emit("send-request", {"action": "mission-result", "roomId": this.roomId, "userId": this.userId, data: {}})
    }
  },
  created (){
    var self = this
    this.socket.onmessage = function(event){
      // self.$store.commit('clearVotes')
      console.log("Received")
      console.log(event)
      const res = JSON.parse(event.data)
      if (!res.state) {return}
      self.$store.commit('setMissionCards', {"missionCards": {"success": res.data.missionSuccess, "fail": res.data.missionFail}})

      if (res.data.spotlight){
        var snackText = "注目の的の効果により，"
        snackText += self.$store.getters.getUserById(res.data.spotlight).name
        if (res.data.deliver=='true'){
          snackText += "がミッションを完遂したことが判明しました．"
        }else if(res.data.deliver=='false'){
          snackText += "がミッションを妨害したことが判明しました．"
        }
        self.$emit("show-text", {state: "spotlight-effect", text: snackText})
      }

      var text = "ミッションは"
      if (res.data.missionFail < self.requiredFails[self.round]) {
        text += "成功しました．\n"
        self.$store.commit('setResult', {result: 'success', round: self.round})
      }else {
        text += "失敗しました．\n"
        self.$store.commit('setResult', {result: 'fail', round: self.round})
      }

      if (res.state == "checking-plot" || res.state == "assigning-mission"){
        // 陰謀カードの処理
        if (res.data.plots){
          self.$store.commit('addDrawnPlots', {plots: res.data.plots, round: self.round+1})
        }

        var nextLeader = self.$store.getters.getUserById(res.data['next-leader'])
        text += "リーダーが" + nextLeader.name + "に移ります．"

        self.$store.commit('setLeader', {userId: res.data['next-leader']})
        if (self.userId == res.data['next-leader']){
          self.$store.commit('beLeader')
        }else {
          self.$store.commit('beMember')
        }
      }else if (res.state == "game-finish"){
        self.$store.commit('setWinner', {winner: res.data.winner})
        if (res.data.winner == "spy"){
          text += "その結果スパイの勝利となりました．"
        }else {
          text += "その結果レジスタンスの勝利となりました．"
        }
      }

      self.$emit("show-text", {state: "mission-complete", text: text})

      var nextState = "wait-strong-leader"
      if (res.state == "wait-strong-leader"){
        nextState = "waitStrongLeader"
      }else if (res.state == "checking-plot"){
        nextState = "checkingPlot"
      }else if (res.state == "assigning-mission"){
        nextState = "assigningMission"
      }else if (res.state == "game-finish"){
        nextState = "result"
      }
      self.$emit("proceed-state", nextState)
    }
    // テスト用
    // this.isLeader = true
  }
}
</script>
<style>
#missionCompleted .send-button {
  padding-bottom: 12px;
}
</style>
